import { gql } from '@apollo/client';

export default gql`
   query MenuFilter {
        menuFilter {
            periods {
                start
                end
                isVisibleInFilter
                categories {
                    id
                    title
                    description
                }
                tags {
                    id
                    title
                    categoryId: category_id
                    categoryName: category_name
                    erp_id
                }
            }
            subdivision
        }
    }
`;
